module.exports = __webpack_public_path__ + "media/images/icons/telegram-8fa2d0664442c15604d83407bfd3d38c.svg";